import React from 'react'
import strings from 'strings'
import { formatRelative, statusPillModifier } from './ctHelpers'

const TaskRow = ({ task, onOpen }) => {
    if (!task) return null
    const t = strings.CT
    const statusKey = statusPillModifier(task.status)
    const lastEventReason = task.status === 'REJECTED'
        ? findLastReason(task)
        : null

    const open = () => onOpen(task)
    const onKeyDown = (e) => {
        // Activate on Enter / Space like a native button.
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault()
            open()
        }
    }

    return (
        <div
            className="ct-row"
            role="button"
            tabIndex={0}
            onClick={open}
            onKeyDown={onKeyDown}
            aria-label={`Open task: ${task.title}`}
        >
            <div className="ct-row__top">
                <span className={`ct-status-pill ct-status-pill--${statusKey}`}>
                    {t[`STATUS_${task.status}`] || task.status}
                </span>
                <span className="ct-row__timestamp">{formatRelative(task.updatedAt || task.createdAt)}</span>
            </div>

            <div className="ct-row__title">{task.title}</div>
            {task.description && <div className="ct-row__description">{task.description}</div>}

            {lastEventReason && (
                <div className="ct-row__rejection-citation">"{lastEventReason}"</div>
            )}

            <div className="ct-row__meta">
                {task.assignee ? (
                    <>
                        <span>{t.ASSIGNED_TO}</span>
                        <span className="ct-email-link">{task.assignee.email}</span>
                        {task.assignee.external && <span className="ct-ext-badge">{t.EXT_BADGE}</span>}
                    </>
                ) : (
                    <span className="ct-unassigned">{t.UNASSIGNED}</span>
                )}
                <span className="ct-meta-sep">·</span>
                <span>{t.BY} <strong style={{ color: 'var(--neutral-900)' }}>{task.assigner?.name || task.assigner?.email || '—'}</strong></span>
            </div>
        </div>
    )
}

/** Pull the most recent REJECTED event's reason out of the timeline (if loaded). */
const findLastReason = (task) => {
    if (!task?.timeline || task.timeline.length === 0) return null
    for (let i = task.timeline.length - 1; i >= 0; i--) {
        const ev = task.timeline[i]
        if (ev.eventType === 'REJECTED' && ev.reason) return ev.reason
    }
    return null
}

export default TaskRow
